var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("article", { staticClass: "d-flex position-relative mb-3" }, [
    _c("a", {
      staticClass: "Card-link Card-link--secondary stretched-link",
      attrs: { href: `${_vm.link}` },
    }),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "Post-image",
        style: `background-image: url('${_vm.post.imagePath}')`,
      },
      [
        _vm.post.eventTC
          ? _c("div", { staticClass: "position-absolute top-0 left-0" }, [
              _vm._m(0),
            ])
          : _vm._e(),
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "p-3 p-md-3 w-100 min-w-0" }, [
      _c("div", { staticClass: "row mb-2" }, [
        _c("div", { staticClass: "col-md-9" }, [
          _c("h3", { staticClass: "h5 Post-header mb-2 mb-lg-0" }, [
            _vm._v(_vm._s(_vm.post.title)),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-3 text-md-right" }, [
          _vm.isActionContinues(_vm.post.dateFrom, _vm.post.dateTo) &&
          _vm.isDateShow
            ? _c("p", { staticClass: "h5 font-size-sm" }, [
                _vm._v(
                  "\n          " + _vm._s(_vm.i18nValue.today) + "\n        "
                ),
              ])
            : _vm._e(),
        ]),
      ]),
      _vm._v(" "),
      _vm.post.dateFrom && _vm.post.dateTo
        ? _c("p", { staticClass: "font-size-sm" }, [
            _c("span", { staticClass: "font-weight-semi-bold" }, [
              _vm._v(_vm._s(_vm.i18nValue.when) + ": "),
            ]),
            _vm._v(
              "\n      " +
                _vm._s(
                  _vm.intervalFormatted(_vm.post.dateFrom, _vm.post.dateTo)
                ) +
                "\n    "
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("p", { staticClass: "font-size-sm" }, [
        _c("span", { staticClass: "font-weight-semi-bold" }, [
          _vm._v(_vm._s(_vm.i18nValue.where) + ": "),
        ]),
        _vm._v(_vm._s(_vm.post.venue)),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "d-none d-xl-flex flex-column justify-content-center flex-shrink-0",
      },
      [
        _c("div", { staticClass: "Post-arrow" }, [
          _c("svg", { staticClass: "icon-small ml-2" }, [
            _c("use", { attrs: { "xlink:href": "#icon-chevron-right" } }),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "ActionFeature" }, [
      _c("img", {
        staticClass: "img-fluid",
        attrs: {
          alt: "logo",
          src: require("@/components/navigation/orp-logo.svg"),
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }